import { filterColors } from '@utils/colorPalette';

export const getSankeyData = (data: any) => {
  const dataToReturn: any = {
    impactAvoided: [],
    timeAvoided: [],
  };
  const combinationMap: any = {};
  data.forEach((item: any) => {
    const key = `${item.resource}_${item.asnname}`;
    if (key in combinationMap) {
      // If the combination exists, update the results
      dataToReturn.timeAvoided[combinationMap[key]].value += Number(item.totaltime);
      dataToReturn.impactAvoided[combinationMap[key]].value += Number(item.kpisamplesize);
    } else {
      // If the combination is new, add to results and update the map
      combinationMap[key] = dataToReturn.timeAvoided.length;
      dataToReturn.timeAvoided.push({
        source: item.resource,
        target: item.asnname,
        value: Number(item.totaltime),
      });
      dataToReturn.impactAvoided.push({
        source: item.resource,
        target: item.asnname,
        value: Number(item.kpisamplesize),
      });
    }
  });
  return dataToReturn;
};

const getNodes = (data: any) => {
  const nodes = new Set<string>();
  data.forEach((link: any) => {
    nodes.add(link.source);
    nodes.add(link.target);
  });
  return Array.from(nodes).map((node, i) => ({
    name: node,
    itemStyle: {
      color: filterColors[i % filterColors.length],
    },
  }));
};

export const buildSankeyOption = (data: any, type: string) => {
  const links = data;
  const nodes = getNodes(data);
  return {
    tooltip: {
      trigger: 'item',
      triggerOn: 'mousemove',
      formatter: (params: any, second) => {
        if (type === 'kpiSampleSize') {
          return `${params.name} : ${params.value}`;
        }
        return `${params.name} : ${params.value} mins`;
      },
    },
    series: {
      type: 'sankey',
      layout: 'none',
      data: nodes,
      links,
      itemStyle: {
        borderWidth: 1,
        borderColor: '#aaa',
      },
      lineStyle: {
        color: 'source',
        curveness: 0.5,
      },
    },
  };
};
